import React, { Suspense } from 'react';
import { CircularProgress } from '../Common';

const Company = React.lazy(() => import('./Company'));

// Show a spinner while the profile is loading
export default function Root(): JSX.Element {
  return (
    <Suspense fallback={<CircularProgress />}>
      <Company />
    </Suspense>
  );
}
